const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

function requestPopUps() {
    return {
        type: actionTypes.BROKER_INFORMATIVE_POPUPS_FETCHING
    };
}

function requestPopUpsSuccess(response) {
    return {
        type: actionTypes.BROKER_INFORMATIVE_POPUPS_SUCCESS,
        payload: {
            data: response,
        }
    };
}

function requestPopUpsFailure() {
    return {
        type: actionTypes.BROKER_INFORMATIVE_POPUPS_ERROR,
    };
}

const getPopUpsInfo = () => (dispatch) => {
    dispatch(requestPopUps());
    APIGet(dispatch, apiURLBuilder.getURL('brokerInformativePopUps'))
            .then((response) => dispatch(requestPopUpsSuccess(response)) )
            .catch(() => dispatch(requestPopUpsFailure()));
}

module.exports = {
    getPopUpsInfo,
};